import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Radio } from "antd";

const storageKey = "addressSearch";

function AddressTypeSelect({ type, onSetValue }) {
  const intl = useIntl();

  const key = `${storageKey}${type}`;

  const [current, setCurrent] = useState(localStorage.getItem(key) || "ALL");
  const handleChange = useCallback(
    ({ target: { value } }) => {
      setCurrent(value);
      localStorage.setItem(key, value);
    },
    [key]
  );

  useEffect(() => {
    onSetValue && onSetValue(current);
  }, [current, onSetValue]);

  return (
    <Radio.Group onChange={handleChange} defaultValue={current}>
      <Radio value="ALL">
        {intl.formatMessage({
          id: "address.search.all",
          defaultMessage: "všechny adresy",
        })}
      </Radio>
      <Radio value="PC">
        {intl.formatMessage({
          id: "address.search.pickup",
          defaultMessage: "pouze nakládkové",
        })}
      </Radio>
      <Radio value="DL">
        {intl.formatMessage({
          id: "address.search.delivery",
          defaultMessage: "pouze vykládkové",
        })}
      </Radio>
    </Radio.Group>
  );
}

export default AddressTypeSelect;
